/**
 * Product Title Dynamic Update (PDP Optimized - V3)
 * 
 * This script updates the product title based on the selected variant options.
 * It targets .product-details h1 and related title links.
 */

(function () {
    const TITLE_SELECTORS = ['.product-details h1', '.view-product-title a', '.product-title h1', 'h1.product-title'];
    let currentObserver = null;
    let observedElement = null;

    function init() {
        const variantPicker = document.querySelector('variant-picker, .variant-picker');
        if (!variantPicker) return;

        // Capture initial state scoped to product ID
        const productId = variantPicker.getAttribute('data-product-id') || 'default';
        if (!window._initialProductBaseTitles) window._initialProductBaseTitles = {};

        TITLE_SELECTORS.forEach(selector => {
            const el = document.querySelector(selector);
            if (el && !window._initialProductBaseTitles[productId + selector]) {
                window._initialProductBaseTitles[productId + selector] = el.innerText;
            }
        });

        // Handle Observer (re-bind if picker element changed via AJAX)
        if (observedElement !== variantPicker) {
            if (currentObserver) {
                currentObserver.disconnect();
            }
            currentObserver = new MutationObserver(() => updateTitle());
            currentObserver.observe(variantPicker, {
                attributes: true,
                childList: true,
                subtree: true,
                attributeFilter: ['data-variant-id', 'class', 'checked']
            });
            observedElement = variantPicker;
        }

        updateTitle();
    }

    function updateTitle() {
        const variantPicker = document.querySelector('variant-picker, .variant-picker');
        if (!variantPicker) return;

        const productId = variantPicker.getAttribute('data-product-id') || 'default';

        let seaterCount = null;
        let sizeName = null;

        // Robust Value Extraction
        // 1. Check checked radio inputs and their labels
        const checkedInput = variantPicker.querySelector('input:checked, option:selected');
        if (checkedInput) {
            let rawValue = checkedInput.value || '';
            const label = checkedInput.closest('label');
            if (label) {
                // Priority: The text span inside the label (requested by user)
                const textSpan = label.querySelector('.variant-option__button-label__text');
                if (textSpan) rawValue = textSpan.innerText;
            }

            if (rawValue) {
                processValue(rawValue.trim());
            }
        }

        // 2. Fallback: Check elements with active classes (swatches, etc)
        if (!seaterCount && !sizeName) {
            const activeElements = variantPicker.querySelectorAll('.is-active, .variant-option__button-label--checked [data-value]');
            activeElements.forEach(el => {
                let val = el.getAttribute('data-value') || el.innerText || el.title;
                if (val) processValue(val.trim());
            });
        }

        function processValue(val) {
            // Extract Seater Count
            const seaterMatch = val.match(/^(\d+)\s*Seater/i);
            if (seaterMatch) seaterCount = seaterMatch[1];

            // Extract Bed Size
            if (/King\s*Size/i.test(val)) sizeName = "King Size";
            if (/Queen\s*Size/i.test(val)) sizeName = "Queen Size";
        }

        // Update all target elements in the DOM
        TITLE_SELECTORS.forEach(selector => {
            const titleEl = document.querySelector(selector);
            if (!titleEl) return;

            let baseTitle = window._initialProductBaseTitles[productId + selector] || titleEl.innerText;
            let newTitle = baseTitle;

            if (seaterCount) {
                // Replace Seater word count
                newTitle = newTitle.replace(/(\d+)(\s*-?\s*)(Seater)/gi, seaterCount + "$2$3");
                // Update Chairs count proportionally
                newTitle = newTitle.replace(/(\d+)(\s*-?\s*)(Chairs)/gi, seaterCount + "$2$3");
            }

            if (sizeName) {
                // Replace Bed Size
                newTitle = newTitle.replace(/(King|Queen)(\s*Size)/gi, sizeName);
            }

            if (titleEl.innerText !== newTitle) {
                titleEl.innerText = newTitle;
            }
        });
    }

    // Global Event Listeners (Persist across AJAX swings)
    document.body.addEventListener('change', (e) => {
        if (e.target.closest('variant-picker') || e.target.closest('.variant-picker')) {
            setTimeout(updateTitle, 100);
        }
    }, true);

    document.body.addEventListener('variant:change', () => setTimeout(updateTitle, 100));

    // --- Start Logic ---
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', init);

    // Persistence Interval: Re-init if picker exists but observer is lost or product changed
    setInterval(() => {
        const picker = document.querySelector('variant-picker, .variant-picker');
        if (picker) {
            if (observedElement !== picker) {
                init();
            }
        }
    }, 1000);

})();
